import React from "react";
import styled from "styled-components";

interface Props {
  title: string,
  chart: JSX.Element,
  chartLegend?: JSX.Element,
}

const StyledChartWithTitle = styled.div`
  color: #434343;
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  padding-left: 2%;
  padding-right: 2%;

  & .chartTitle {
    flex: 0 0 auto;
    font-family: MapfreText-Bold;
    font-size: 18px;
    margin-bottom: 40px;
  }

  
    @media (min-width: 481px) {
      & .chart {
        flex: 1 1 auto;
        min-height: 500px;
      }
  }

  @media (max-width: 480px) {
      & .chart {
        flex: 1 1 auto;
      }
  }
`;

const BranchChartWithTitle = ({ title, chart, chartLegend }: Props) => {
  return (
    <StyledChartWithTitle>
      <h3 className='chartTitle'>
        { title }
      </h3>
      <div className='chart'>
      { chartLegend !== undefined && (
          <div className='chart-legend'>
              { chartLegend }
          </div>
      )
      }
        { chart }
      </div>
    </StyledChartWithTitle>
  )
};

export default BranchChartWithTitle;
